module.exports = __webpack_public_path__ + "img/img15.f838d7ac.png";